import type { ReactNode } from "react";

interface ShirorekhaProps {
  children: ReactNode;
  className?: string;
}

/**
 * Shirorekha — the headline bar that Devanagari letters hang from.
 *
 * The recurring structural motif of the whole UI: a hairline horizontal
 * rule with content suspended beneath it, the way अक्षर hang from the
 * shirorekha of a word. The rule is `--color-rule`; content is pushed
 * down so it reads as *hanging*, not sitting on top.
 */
export function Shirorekha({ children, className = "" }: ShirorekhaProps) {
  return (
    <div className={`border-t border-rule pt-3 ${className}`}>{children}</div>
  );
}
